import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_IEB() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  const getIEBData = async () => {
    const { headers } = await queryParamsAndHeaders({});

    return apiCall({
      url: `${backendUrl}/api/ieb_files`,
      headers,
    });
  };

  const setFileAsIEB = async (affiliate, processedDate) => {
    // value is processed date to set, null to unset
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      setting: "ieb_file",
      value: processedDate,
    });
    return apiCall({
      url: `${backendUrl}/api/preferences?${queryString}`,
      method: "PUT",
      headers,
    });
  };

  const changeIEBDate = async (newIEBDate) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      ieb_date: newIEBDate,
    });

    return apiCall({
      url: `${backendUrl}/api/reset_ieb?${queryString}`,
      method: "PUT",
      headers,
    });
  };

  return {
    getIEBData,
    setFileAsIEB,
    changeIEBDate,
  };
}
